import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import {
  ThemeProvider as MuiThemeProvider,
  createTheme
} from '@mui/material/styles';

import palette from './palette';
import typography from './typography';
import { frFR, itIT, enUS, Localization } from '@mui/material/locale';

type ThemeProviderProps = {
  children: React.ReactNode;
  /**
   * Language to use for i18n
   */
  locale: string;
};

const languages: Record<string, Localization> = {
  fr: frFR,
  it: itIT,
  en: enUS
};

const ThemeProvider = ({ children, locale = 'en' }: ThemeProviderProps) => {
  const muiTheme = createTheme(
    {
      palette,
      typography,
      // Use a 4px spacing factor instead of 8 by default
      spacing: 4,
      components: {
        MuiFormControlLabel: {
          styleOverrides: {
            label: {
              ...typography.body2
            }
          }
        }
      }
    },
    languages[locale]
  );
  /**
   * MUIThemeProvider: Mui Theming
   * StyledComponentsThemeProvider: Pass Mui theme to Styled Components
   */
  return (
    <MuiThemeProvider theme={muiTheme}>
      <StyledComponentsThemeProvider theme={muiTheme}>
        {children}
      </StyledComponentsThemeProvider>
    </MuiThemeProvider>
  );
};

export { ThemeProvider };
